import { Injectable } from "@angular/core";
import { NgxScannerQrcodeComponent, ScannerQRCodeResult } from "ngx-scanner-qrcode";

@Injectable({
    providedIn: 'root'
})
export class QRCodeHelper {

    constructor(

    ) { }

    async getReverseCamera(action: NgxScannerQrcodeComponent) {
        try {
            const playDeviceFacingBack = (devices: any[]) => {
                console.log(devices)
                const device = devices.find(f => (/back|rear|environment/gi.test(f.label)));
                if (action)
                    action.playDevice(device ? device.deviceId : devices[1] ? devices[1].deviceId : devices[0].deviceId);
            }
            action.stop();
            setTimeout(() => {
                action.start(playDeviceFacingBack)
            }, 200);
        } catch (error) {
            console.log(error);
            console.log(action)
            this.getReverseCamera(action);
        }

    }
    getScannedValue(action: NgxScannerQrcodeComponent, e: ScannerQRCodeResult[]) {
        action.pause();
        return e[0].value;
    }

}